import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import configs from './modules/configs'
import adminMode from './modules/admin/adminMode'
import adminDoctors from './modules/admin/adminDoctors'
import adminAlternativeDoctorMenus from './modules/admin/adminAlternativeDoctorMenus'
import adminDoctorsMatching from './modules/admin/adminDoctorsMatching'
import adminUsers from './modules/admin/adminUsers'
import adminCompanies from './modules/admin/adminCompanies'
import adminOrganizations from './modules/admin/adminOrganizations'
import adminOrganizationCompanies from './modules/admin/adminOrganizationCompanies'
import adminInvoices from './modules/admin/adminInvoices'
import adminSubscriptionReviews from './modules/admin/adminSubscriptionReviews'
import adminInterviewTransProfiles from './modules/admin/adminInterviewTransProfiles'
import adminCoupons from './modules/admin/adminCoupons'
import adminUserCoupons from './modules/admin/adminUserCoupons'
import adminCouponCodes from './modules/admin/adminCouponCodes'
import adminCompanyUsers from './modules/admin/adminCompanyUsers'
import adminCompanyInvoices from './modules/admin/adminCompanyInvoices'
import adminCompanyConsultations from './modules/admin/adminCompanyConsultations'
import adminCompanySubscriptions from './modules/admin/adminCompanySubscriptions'
import adminCompanyInvitations from './modules/admin/adminCompanyInvitations'
import adminCompanyHealthSurveys from './modules/admin/adminCompanyHealthSurveys'
import adminCompanyHealthSurveyReports from './modules/admin/adminCompanyHealthSurveyReports'
import adminGroupFormTokens from './modules/admin/adminGroupFormTokens'
import adminOrganizationUsers from './modules/admin/adminOrganizationUsers'
import adminOrganizationInvoices from './modules/admin/adminOrganizationInvoices'
import adminOrganizationConsultations from './modules/admin/adminOrganizationConsultations'
import adminOrganizationSubscriptions from './modules/admin/adminOrganizationSubscriptions'
import adminOrganizationInvitations from './modules/admin/adminOrganizationInvitations'
import adminOrganizationHealthSurveys from './modules/admin/adminOrganizationHealthSurveys'
import adminPlans from './modules/admin/adminPlans'
import adminMedicalCourses from './modules/admin/adminMedicalCourses'
import adminAudits from './modules/admin/adminAudits'
import userMode from './modules/user/userMode'
import userConsultations from './modules/user/userConsultations'
import userCompanyUsers from './modules/user/userCompanyUsers'
import userCompanyConsultations from './modules/user/userCompanyConsultations'
import userCompanySubscriptions from './modules/user/userCompanySubscriptions'
import userCompanyInvitations from './modules/user/userCompanyInvitations'
import userCompanyHealthSurveys from './modules/user/userCompanyHealthSurveys'
import userOrganizationUsers from './modules/user/userOrganizationUsers'
import userOrganizationCompanies from './modules/user/userOrganizationCompanies'
import userOrganizationConsultations from './modules/user/userOrganizationConsultations'
import userOrganizationSubscriptions from './modules/user/userOrganizationSubscriptions'
import userOrganizationInvitations from './modules/user/userOrganizationInvitations'
import userOrganizationHealthSurveys from './modules/user/userOrganizationHealthSurveys'
import userOrganizationGroupManagementTags from './modules/user/userOrganizationGroupManagementTags'
import userOrganizationUserManagementTags from './modules/user/userOrganizationUserManagementTags'
import userVideoSettings from './modules/user/userVideoSettings'
import userInvoices from './modules/user/userInvoices'
import userInterviewTransAnswers from './modules/user/userInterviewTransAnswers'
import reservation from './modules/user/reservation'
import doctorMode from './modules/doctor/doctorMode'
import doctorReservation from './modules/doctor/doctorReservation'
import doctorVideoSettings from './modules/doctor/doctorVideoSettings'
import doctorInvoices from './modules/doctor/doctorInvoices'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        configs,
        adminMode,
        adminDoctors,
        adminAlternativeDoctorMenus,
        adminDoctorsMatching,
        adminUsers,
        adminCompanies,
        adminOrganizations,
        adminOrganizationCompanies,
        adminInvoices,
        adminSubscriptionReviews,
        adminInterviewTransProfiles,
        adminCoupons,
        adminUserCoupons,
        adminCouponCodes,
        adminCompanyUsers,
        adminCompanyInvoices,
        adminCompanyConsultations,
        adminCompanySubscriptions,
        adminCompanyInvitations,
        adminCompanyHealthSurveys,
        adminCompanyHealthSurveyReports,
        adminOrganizationUsers,
        adminOrganizationInvoices,
        adminOrganizationConsultations,
        adminOrganizationSubscriptions,
        adminOrganizationInvitations,
        adminOrganizationHealthSurveys,
        adminGroupFormTokens,
        adminPlans,
        adminMedicalCourses,
        adminAudits,
        userMode,
        userConsultations,
        userCompanyUsers,
        userCompanyConsultations,
        userCompanySubscriptions,
        userCompanyInvitations,
        userCompanyHealthSurveys,
        userOrganizationUsers,
        userOrganizationCompanies,
        userOrganizationConsultations,
        userOrganizationSubscriptions,
        userOrganizationInvitations,
        userOrganizationHealthSurveys,
        userOrganizationGroupManagementTags,
        userOrganizationUserManagementTags,
        userVideoSettings,
        userInvoices,
        userInterviewTransAnswers,
        reservation,
        doctorMode,
        doctorReservation,
        doctorVideoSettings,
        doctorInvoices,
    },
    plugins: [
        createPersistedState({
            key: 'yokumiruWeb',
            paths: [
                'adminMode',
                'adminDoctors',
                'adminUsers',
                'adminCompanies',
                'adminOrganizations',
                'adminInvoices',
                'adminSubscriptionReviews',
                'adminInterviewTransProfiles',
                'adminCoupons',
                'adminUserCoupons',
                'adminCouponCodes',
                'adminCompanyUsers',
                'adminCompanyInvoices',
                'adminCompanyConsultations',
                'adminCompanySubscriptions',
                'adminCompanyInvitations',
                'adminOrganizationUsers',
                'adminOrganizationInvoices',
                'adminOrganizationConsultations',
                'adminOrganizationSubscriptions',
                'adminOrganizationInvitations',
                'adminGroupFormTokens',
                'adminPlans',
                'adminMedicalCourses',
                'adminAudits',
                'userMode',
                'userConsultations',
                'userCompanyUsers',
                'userCompanyConsultations',
                'userCompanySubscriptions',
                'userCompanyInvitations',
                'userOrganizationUsers',
                'userOrganizationCompanies',
                'userOrganizationConsultations',
                'userOrganizationSubscriptions',
                'userOrganizationInvitations',
                'userOrganizationGroupManagementTags',
                'userOrganizationUserManagementTags',
                'userVideoSettings',
                'userInvoices',
                'doctorMode',
                'doctorVideoSettings',
                'doctorInvoices',
            ],
            storage: window.localStorage,
        })
    ],
})
